import { TranslationKeys } from '@I18n/types';
import { makeChoices } from '@Utils/makeChoices';

export type SubjectChoiceKeys =
  | 'matching_contribution'
  | 'navigation_help'
  | 'contribution_call'
  | 'arbitration'
  | 'amendment'
  | 'bia'
  | 'monetized_leave'
  | 'death'
  | 'nominative_declaration'
  | 'evaluation_request'
  | 'dsn'
  | 'taxation'
  | 'merger'
  | 'end_of_career_bonus'
  | 'liquidation'
  | 'administrative_change'
  | 'annuity_payment'
  | 'profit_sharing'
  | 'regularization'
  | 'redemption'
  | 'contract_termination'
  | 'account_statement'
  | 'pricing_commercial'
  | 'transfer'
  | 'payment'
  | 'other'
  | 'complaint';

const subjects = {
  matching_contribution:
    'contact_support_page.contact_request.choices.subject.matching_contribution',
  navigation_help: 'contact_support_page.contact_request.choices.subject.navigation_help',
  contribution_call: 'contact_support_page.contact_request.choices.subject.contribution_call',
  arbitration: 'contact_support_page.contact_request.choices.subject.arbitration',
  amendment: 'contact_support_page.contact_request.choices.subject.amendment',
  bia: 'contact_support_page.contact_request.choices.subject.bia',
  monetized_leave: 'contact_support_page.contact_request.choices.subject.monetized_leave',
  death: 'contact_support_page.contact_request.choices.subject.death',
  nominative_declaration:
    'contact_support_page.contact_request.choices.subject.nominative_declaration',
  evaluation_request: 'contact_support_page.contact_request.choices.subject.evaluation_request',
  dsn: 'contact_support_page.contact_request.choices.subject.dsn',
  taxation: 'contact_support_page.contact_request.choices.subject.taxation',
  merger: 'contact_support_page.contact_request.choices.subject.merger',
  end_of_career_bonus: 'contact_support_page.contact_request.choices.subject.end_of_career_bonus',
  liquidation: 'contact_support_page.contact_request.choices.subject.liquidation',
  administrative_change:
    'contact_support_page.contact_request.choices.subject.administrative_change',
  annuity_payment: 'contact_support_page.contact_request.choices.subject.annuity_payment',
  profit_sharing: 'contact_support_page.contact_request.choices.subject.profit_sharing',
  regularization: 'contact_support_page.contact_request.choices.subject.regularization',
  redemption: 'contact_support_page.contact_request.choices.subject.redemption',
  contract_termination: 'contact_support_page.contact_request.choices.subject.contract_termination',
  account_statement: 'contact_support_page.contact_request.choices.subject.account_statement',
  pricing_commercial: 'contact_support_page.contact_request.choices.subject.pricing_commercial',
  transfer: 'contact_support_page.contact_request.choices.subject.transfer',
  payment: 'contact_support_page.contact_request.choices.subject.payment',
  other: 'contact_support_page.contact_request.choices.subject.other',
  complaint: 'contact_support_page.contact_request.choices.subject.complaint',
} satisfies Record<SubjectChoiceKeys, TranslationKeys>;

export const contactFormSubjectChoices = makeChoices<SubjectChoiceKeys>(subjects);
